export default __webpack_public_path__ + "static/media/aim.6cf8f529.png";